import React, { PureComponent } from 'react'
import { injectIntl } from 'react-intl'
import Loader from './Loader'

import './Validation.css'

export default injectIntl(
  class Validation extends PureComponent {
    render() {
      const { intl, validation, validating } = this.props
      return validating ? (
        <Loader loading={true} />
      ) : (
        <button className="cm-validation" onClick={validation}>
          {intl.messages.validation}
        </button>
      )
    }
  }
)



// WEBPACK FOOTER //
// ./src/Validation.js